/**
 * Created by Slava on 28.06.2024
 */

cleverapps.override(cleverapps.EVENTS, {
    SCORE_LEVEL: "score_level",

    SPENT: {
        VILLAGE_HUT: "village_hut"
    },

    EARN: {
        LEVELMASTERY: "levelmastery",
        VILLAGE_ATTACK: "village_attack",
        VILLAGE_RAID: "village_raid",
        INGAME_AD: "ingame_ad"
    },

    STATS: {
        LEVEL_LOST_TIME: "lvl_lost_time_",
        LEVEL_LOST_COUNT: "lvl_lost_count_"
    }
});
